import { toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "modal-footer" }
const _hoisted_5 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade show opacity-100 d-flex align-items-center justify-content-center",
    style: {"background-color":"rgba(0, 0, 0, 0.5)"},
    onClick: _cache[2] || (_cache[2] = (...args) => ($options.handle_close && $options.handle_close(...args)))
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-dialog-centered",
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString($props.title) + " ", 1 /* TEXT */),
          ($props.message_name)
            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                key: 0,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.user_message) = $event)),
                class: "form-control mt-3",
                cols: "40",
                placeholder: $props.message_name,
                rows: "5",
                type: "text"
              }, null, 8 /* PROPS */, _hoisted_3)), [
                [_vModelText, $data.user_message]
              ])
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.buttons, (label, key, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: key,
              ref_for: true,
              ref: key,
              class: _normalizeClass(["btn", $options.get_button_class(key, index)]),
              type: "button",
              onClick: $event => ($options.handle_close(key))
            }, _toDisplayString(label), 11 /* TEXT, CLASS, PROPS */, _hoisted_5))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}